export default "__VITE_ASSET__aa4038e5__"